import { extend, locale, Ls } from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/sv';
import 'dayjs/locale/nb';
import 'dayjs/locale/da';
import 'dayjs/locale/fi';
import 'dayjs/locale/pl';
import 'dayjs/locale/en-gb';

extend(localizedFormat);

// Overwrite 'en' locale with 'en-gb' locale
locale('en', Ls['en-gb'], true);

// Create 'no' locale from 'nb' locale
locale('no', Ls.nb);

// Set default locale to 'en'
locale('en');

export const initializeDayjs = (languageCode: string) => {
  locale(languageCode);
};
